<app-side-nav *ngIf="showSideNav" (openFirmPicker)="openFirmPicker.emit()"></app-side-nav>
<main class="app-main" [class.no-side-nav]="!showSideNav">
  <div class="app-content-wrapper">
    <ng-content></ng-content>
  </div>
</main>
